module.exports = __webpack_public_path__ + "static/media/power-plant.5460e3c8.svg";